module.exports = __webpack_public_path__ + "static/media/28DGC6.a15b1d7b.jpg";